<template>
  <div class="row pt-5 justify-content-center">
    <div class="row col-10 justify-content-center">
      <div class="col-10 col-sm-5 col-md-4 col-lg mt-2 mt-md-0 d-flex">
        <a href="https://www.generali.sk/sk/" target="_blank" class="m-auto logo-customer">
          <img src="~@/assets/img/customers/generali_logo.svg" alt="Generali logo" height="45px">
        </a>
      </div>
      <div class="order-sm-1 col-10 col-sm-5 col-md-4 col-lg mt-5 mt-md-0 d-flex">
        <a href="https://www.moneta.cz/" target="_blank" class="m-auto logo-customer">
          <img src="~@/assets/img/customers/moneta_logo.svg" alt="Moneta Money Bank logo" height="25px">
        </a>
      </div>
      <div class="order-sm-2 col-10 col-sm-5 col-md-4 col-lg mt-5 mt-md-0 d-flex">
        <a href="https://www.dpd.com/cz_en" target="_blank" class="m-auto logo-customer">
          <img src="~@/assets/img/customers/dpd_logo.svg" alt="DPD logo" height="40px">
        </a>
      </div>
      <div class="order-3 col-10 col-sm-5 col-md-4 col-lg mt-5 mt-lg-0 d-flex">
        <a href="http://www.sps-sro.sk/en/Welcome-to-the-SPS.html" target="_blank" class="m-auto logo-customer">
          <img src="~@/assets/img/customers/sps_logo.svg" alt="SPS logo" height="35px">
        </a>
      </div>
      <div class="order-4 col-10 col-sm-5 col-md-4 col-lg mt-5 mt-lg-0 d-flex">
        <a href="https://www.mluvii.com/language/en/" target="_blank" class="m-auto logo-customer">
          <img src="~@/assets/img/customers/mluvii_logo.svg" alt="Mluvii logo" height="20px">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CustomerReferences'
  }
</script>

<style lang="scss" scoped>
  $logo-customer-opacity: 0.4;

  .logo-customer {
    opacity: $logo-customer-opacity;
  }

  .logo-customer:hover {
    animation: opaque-in 2s;
    opacity: 1;
  }

  /* prevents rows from creating horizontal scrollbars on mobile sized devices */
  .row {
    margin-left: 0;
    margin-right: 0;
  }

  @keyframes opaque-in {
    from {
      opacity: $logo-customer-opacity;
    }
    to {
      opacity: 1;
    }
  }
</style>
